
import WDElement from './wd-element';

export default class WDElementCollapsible extends WDElement {

  #wrapper;
  #overflow;
  #inTransition = false;
  #connected = false;
  #isCollapsed = false;

  constructor(cfg)
  {
    super(cfg);
    if (cfg?.collapsed !== undefined) this.#isCollapsed = cfg?.collapsed;
  }

  connectedCallback()
  {
    if (this.#connected == true) return;

    super.connectedCallback();

    this.#connected = true;

    this.#wrapper = wdc('<div class="wd-element-collapsible-wrapper"/>');
    if (!this.#isCollapsed) this.#wrapper.classList.add('is-open');

    this.#overflow = wdc('<div class="wd-element-collapsible-overflow"/>');

    this.#wrapper.append(this.#overflow);
    this.before(this.#wrapper);
    this.#overflow.append(this);

    this.#wrapper.addEventListener('transitionstart',(evt) => {

      if (evt.propertyName == 'grid-template-rows')
      {
        this.#inTransition = true;
        const evtName = this.#wrapper.classList.contains('is-open') ? 'element:open' : 'element:close';
        this.trigger(evtName);
      }
    }, { signal: this.abortSignal });

    this.#wrapper.addEventListener('transitionend',(evt) => {

      if (evt.propertyName == 'grid-template-rows')
      {
        this.#inTransition = false;

        const evtName = this.#wrapper.classList.contains('is-open') ? 'element:opened' : 'element:closed';
        this.#wrapper.classList.remove('is-transitioning');
        this.trigger(evtName);
      }
    }, { signal: this.abortSignal });

    // Add ARIA attributes for accessibility
    this.setAttribute('aria-expanded', this.#isCollapsed ? 'false' : 'true');
    this.setAttribute('role', 'region');

    // Update aria-expanded when state changes
    this.on('element:opened', () => this.setAttribute('aria-expanded', 'true'));
    this.on('element:closed', () => this.setAttribute('aria-expanded', 'false'));

  };

  cleanupCallback()
  {
    // Call parent cleanup FIRST
    super.cleanupCallback();
    
    this.#wrapper = null
    this.#overflow = null;
  }

  wrapper() { return this.#wrapper; };

  /** card visibility **/
  open(animated) { 

    if (animated === false)
    {
      this.trigger('element:open');
      this.#wrapper.classList.add('is-open');
      this.trigger('element:opened');
    }
    else
    {
      this.#wrapper.classList.add('is-open', 'is-transitioning');
      this.checkTransition();
    }
  };

  close(animated) { 

    if (!this.#wrapper) return; 
    
    if (animated === false)
    {
      this.trigger('element:close');
      this.#wrapper.classList.remove('is-open');
      this.trigger('element:closed');
    }
    else
    {
      this.#wrapper.classList.add('is-transitioning');
      this.#wrapper.classList.remove('is-open');
      this.checkTransition();
    }
  };

  checkTransition()
  {
    setTimeout( () => {
      if (!this.#inTransition) this.#wrapper.classList.remove('is-transitioning');
    },100);
  };
    
  toggle(animated) 
  { 
    if ( this.isOpen() ) this.close(animated);
    else this.open(animated);
  };

  isOpen() { return this.#wrapper.classList.contains('is-open'); };

};

customElements.define('wd-element-collapsible',WDElementCollapsible);
